import '@babel/polyfill'
import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App.vue'
import service from './axios/request' //ajax
import "@/assets/font/fonts.scss";
import '@/assets/css/common.css'
import $ from 'jquery';
import { HappyScroll } from 'vue-happy-scroll'
import './assets/iconfont/iconfont.css' //图标库
import 'vue-happy-scroll/docs/happy-scroll.css'
import {
  Notification,
  Popconfirm,
  Dialog,
  Button,
  Pagination, Popover, Message, DatePicker, CheckboxGroup, Checkbox, Carousel,
  CarouselItem, Table, TableColumn, Select, Option,Tabs,TabPane
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import animated from "animate.css"
import md5 from 'js-md5';
import echarts from 'echarts'
import 'echarts-gl'
import i18n from './i18n/i18n'
import waterfall from 'vue-waterfall2'
import scroll from 'vue-seamless-scroll'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
//引入axios模块(先下载`axios`--)
import axios from 'axios'
import { promised } from 'q'
import global_ from '@/components/PublicComponents/Global/global'//引用文件
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'
import "@/util/VeeValidate/VeeValidate";
import VueAMap from 'vue-amap';
import kkVueLog from "kk-vue-log"
import 'leaflet/dist/leaflet.css'
// 引入Leaflet对象 挂载到Vue上，便于全局使用，也可以单独页面中单独引用
import * as L from 'leaflet'
Vue.config.productionTip = false;
Vue.L = Vue.prototype.$L = L
import tagCloud from 'v-tag-cloud'
Vue.use(tagCloud)
Vue.use(VueAMap);
Vue.use(Mint);
VueAMap.initAMapApiLoader({
  key: '482182cb728c1d6b46cbc750f924d0d1',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  v: '1.4.4'
});


const options = {
  //v-log="{params:{a:1,b:2}}"
  // 埋点数据上传的接口，必填
  url: "http://www.opendbar.cn/sdg-api/buried/point",

  //埋点数据上传的方法， 可选，不填写默认 'get'
  method: 'post',

  //请求的 headers，(可选) 建议只放常量  (提示, 若需要加token这一类通过接口或者计算出来的参数, 需要放在请求拦截器里, 否则可能取不到值)
  headers: {
    // 'NAME': 'name'
  },
  // 请求拦截执行函数 config为请求的配置 同axios请求拦截器的配置
  interceptorsRequest: function (config) {
    config.headers = {
      // token: '123456'
    }
  },

  // 路由实例 (可选) 如果需要记录页面停留时间和页面跳转来源则必填
  router,

  //一个数组，(可选) 需要记录停留时间的页面vue路由path, 若写['*']则为所有页面
  durationRoute: ['*'],

  // 是否需要记录跳转来源 (可选)
  needReferrer: false,

  //跳转来源的页面标记字段 (可选) 例如 http://www.baidu.com?from=baidu
  sign: 'from'
}

// 使用 
Vue.use(kkVueLog, options)

// import 'vue-fullpage.js/dist/style.css'
// import VueFullPage from 'vue-fullpage.js'
// Vue.use(VueFullPage);

//将axios挂载在vue原型链上
Vue.prototype.GLOBAL = global_//挂载到Vue实例上面
Vue.prototype.$message = Message;
Vue.use(Dialog);
Vue.use(scroll)
Vue.prototype.$video = Video
Vue.use(animated)
Vue.use(TableColumn);
Vue.use(Table);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Tabs);

Vue.use(TabPane);
Vue.use(Checkbox);
Vue.use(Popover);
Vue.use(DatePicker);
Vue.use(Popconfirm)
Vue.use(Button);
Vue.use(Pagination);
Vue.use(CheckboxGroup);
Vue.prototype.$notify = Notification;
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.use(Select);
Vue.use(Option);



Vue.use(VueAwesomeSwiper)
Vue.prototype.$echarts = echarts
Vue.prototype.$md5 = md5;
Vue.component('happy-scroll', HappyScroll)

if (process.env.NODE_ENV === 'production') {
  /*第二层if，根据.env文件中的VUE_APP_FLAG判断是生产环境还是测试环境*/
  if (process.env.VUE_APP_FLAG === 'pro') {
    service.defaults.baseURL = 'http://opendbar.casearth.cn/sdg-api';
    // service.defaults.baseURL = 'http://172.31.11.3:8094/sdg-api';
  } else {
    service.defaults.baseURL = 'http://opendbar.casearth.cn/sdg-api';
    // service.defaults.baseURL = 'http://172.31.11.3:8094/sdg-api';
    // service.defaults.baseURL = 'http://60.245.209.50/sdg-api';

  }
} else {
  // console.log('开发环境')
  service.defaults.baseURL = 'http://opendbar.casearth.cn/sdg-api';
  // service.defaults.baseURL = 'http://172.31.11.3:8094/sdg-api';
  // service.defaults.baseURL = 'http://www.opendbar.cn/sdg-api';

}

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {  
    // 需要权限
    //判断当前是否拥有权限
    if (localStorage.getItem('token')&& localStorage.getItem('loginName')) {
      next();
    } else {  // 无权，跳转登录
      next({
        path: '/login',
        query: { redirect:to.meta.path}
      })
    }
  } else {  // 不需要权限，直接访问
    next();
  }
})
  let vueThis = new Vue({
    router,
    store,
    i18n,
    render: h => h(
      App
    ),
  }).$mount('#app')
  export default vueThis